export const redirect = (uri) => {
    if (window.location.href === uri || !uri) {
        window.location.reload();
    }
    else {
        window.location.href = uri;
    }
};
